import React from 'react';
import { Star, Phone, Mail, CheckCircle, AlertCircle } from 'lucide-react';
import { MOCK_CONTRACTORS } from '../../mock';
import Badge from '../../components/common/Badge';

const AdminContractors: React.FC = () => (
  <div>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
      <h2 style={{ fontWeight: 800, fontSize: '1.5rem', color: 'var(--text-primary)', margin: 0 }}>Contractor Management</h2>
      <button className="btn-primary" style={{ fontSize: '0.875rem' }}>+ Invite Contractor</button>
    </div>

    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '1.25rem' }}>
      {MOCK_CONTRACTORS.map(c => (
        <div key={c.id} className="card card-hover">
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start' }}>
            {c.avatar ? (
              <img src={c.avatar} alt={c.name} style={{ width: '3.5rem', height: '3.5rem', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
            ) : (
              <div style={{ width: '3.5rem', height: '3.5rem', borderRadius: '50%', background: 'linear-gradient(135deg, #f97316, #ea580c)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 700, fontSize: '1.25rem', flexShrink: 0 }}>
                {c.name.charAt(0)}
              </div>
            )}
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <h3 style={{ fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 0.2rem', fontSize: '1rem' }}>{c.name}</h3>
                  <p style={{ color: 'var(--text-muted)', fontSize: '0.8rem', margin: 0 }}>{c.company}</p>
                </div>
                <Badge label={c.status} variant={c.status === 'active' ? 'success' : c.status === 'pending' ? 'warning' : 'danger'} />
              </div>
            </div>
          </div>

          {c.rating > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.75rem' }}>
              {[1,2,3,4,5].map(i => <Star key={i} size={14} fill={i <= Math.floor(c.rating) ? '#f97316' : '#e2e8f0'} stroke="none" />)}
              <span style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--text-primary)' }}>{c.rating}</span>
              <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>({c.reviewCount} reviews)</span>
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.625rem', fontSize: '0.8rem', marginBottom: '1rem' }}>
            {[
              { label: 'License', value: c.licenseNumber },
              { label: 'Completed Jobs', value: c.completedJobs.toString() },
              { label: 'License Expires', value: c.licenseExpiry },
              { label: 'Total Earnings', value: c.earnings > 0 ? `$${c.earnings.toLocaleString()}` : 'N/A' },
            ].map(item => (
              <div key={item.label}>
                <span style={{ color: 'var(--text-muted)', display: 'block', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{item.label}</span>
                <span style={{ color: 'var(--text-primary)', fontWeight: 600 }}>{item.value}</span>
              </div>
            ))}
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <p style={{ fontSize: '0.7rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '0.375rem' }}>Service Areas</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.375rem' }}>
              {c.serviceAreas.map(a => (
                <span key={a} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', borderRadius: '9999px', padding: '0.2rem 0.625rem', fontSize: '0.72rem', color: 'var(--text-secondary)' }}>{a}</span>
              ))}
            </div>
          </div>

          {/* License/Insurance Status */}
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.72rem', color: new Date(c.licenseExpiry) > new Date() ? '#10b981' : '#ef4444' }}>
              {new Date(c.licenseExpiry) > new Date() ? <CheckCircle size={12} /> : <AlertCircle size={12} />}
              License {new Date(c.licenseExpiry) > new Date() ? 'Valid' : 'EXPIRED'}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.72rem', color: new Date(c.insuranceExpiry) > new Date() ? '#10b981' : '#ef4444' }}>
              {new Date(c.insuranceExpiry) > new Date() ? <CheckCircle size={12} /> : <AlertCircle size={12} />}
              Insurance {new Date(c.insuranceExpiry) > new Date() ? 'Valid' : 'EXPIRED'}
            </div>
          </div>

          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button className="btn-ghost" style={{ fontSize: '0.8rem', flex: 1 }}><Phone size={13} /> Call</button>
            <button className="btn-ghost" style={{ fontSize: '0.8rem', flex: 1 }}><Mail size={13} /> Email</button>
            <button className="btn-primary" style={{ fontSize: '0.8rem', flex: 1 }}>Assign Job</button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default AdminContractors;
